export class Comune {
	id!: number;
	pid!: number;
	provincia?: string;
	descrizione?: string;
	sigla?: string;
}
